<app-loading-overlay></app-loading-overlay>
<app-dialog></app-dialog>
<app-header-bar [currentUser$]="currentUser$"></app-header-bar>
<div class="main-view">
  <router-outlet></router-outlet>
</div>
<app-toaster></app-toaster>
<app-footer-bar></app-footer-bar>
